var module = angular.module('octopusApp.tasks');

module.controller('TasksIndexController', function ($scope, $timeout, $location, busy, pollLoop, octopusRepository, octopusPermissionSet) {
    var isLoading = $scope.isLoading = busy.create();

    $scope.tasks = null;
    $scope.skip = 0;
    $scope.skipActive = 0;
    $scope.filter = {
        name: "",
        nodeId: $location.search().serverNode
    };

    $scope.taskTypes = ["Deploy", "Health", "AdHocScript", "AutoDeploy", "Backup", "Upgrade", "TestEmail", "TestAzureAccount", "Retention", "Delete", "SystemIntegrityCheck", "SyncCommunityActionTemplates", "SynchronizeBuiltInPackageRepositoryIndex", "UpdateCalamari"];
    $scope.loadRecentPage = loadRecentPage;
    $scope.loadActivePage = loadActivePage;
    $scope.refresh = refresh;

    function loadRecentPage(skip) {
        $scope.skip = skip;
        loadTasks();
    }

    function loadActivePage(skipActive) {
        $scope.skipActive = skipActive;
        loadTasks();
    }

    function refresh() {
        $scope.skip = 0;
        $scope.skipActive = 0;
        loadTasks();
    }

    isLoading.promise(octopusPermissionSet.isAuthorized({
        permission: 'ProjectView',
        projectId: '*'
    }).then(function (yn) {
        return yn ? octopusRepository.Projects.all().then(function (projects) {
            $scope.projects = projects;
        }) : null;
    }));

    isLoading.promise(octopusPermissionSet.isAuthorized({
        permission: 'EnvironmentView',
        environmentId: '*'
    }).then(function (yn) {
        return yn ? octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        }) : null;
    }));

    isLoading.promise(octopusRepository.OctopusServerNodes.all().then(function (nodes) {
        $scope.nodes = nodes;
    }));

    function loadTasks() {
        var options = {
            environment: $scope.filter.environmentId,
            name: $scope.filter.name || null,
            project: $scope.filter.projectId,
            node: $scope.filter.nodeId
        };

        return isLoading.promise(octopusRepository.Tasks.filter(angular.extend({}, options, {
            skip: $scope.skip,
            active: false
        })).then(function (tasks) {
            return isLoading.promise(octopusRepository.Tasks.filter(angular.extend({}, options, {
                skip: $scope.skipActive,
                active: true
            })).then(function (activeTasks) {
                $scope.tasks = tasks;
                $scope.activeTasks = activeTasks;
            }));
        }));
    }

    pollLoop.create($scope, function () {
        return loadTasks();
    }).startImmediately();

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/controllers/tasks_index_controller.js
// module id = 614
// module chunks = 1